import React, { Component } from 'react';
import { connect } from 'react-redux';
import NProgress from 'nprogress'

class NProgressBar extends Component {
	componentDidMount() {
		const {running} = this.props
		//console.log('will mount')
		if (running) {
			NProgress.start()
			this.timer = setInterval(() => NProgress.inc(), 400)
		} else {
			setTimeout(() => {if(!this.unmounted && !this.props.running) NProgress.done()}, 400)
		}
	}
	
	componentDidUpdate(prevProps) {
		if(this.props.running) {
			if(!prevProps.running) {
				NProgress.start()
				this.timer = setInterval(() => NProgress.inc(), 400)
			}
			if(this.props.step>=0) {
				if(this.timer) clearInterval(this.timer)
				NProgress.set(this.props.step)
			}
		} else {
			if(this.timer) clearInterval(this.timer)
			NProgress.set(0.9)
			setTimeout(() => {
				if (!this.unmounted &&
				    !this.props.running) NProgress.done()
			}, 1000)
		}
	}
	/*componentWillReceiveProps(nextProps) {
		//console.log(nextProps.running)
		if(nextProps.running) {
			if(!this.props.running) {
				NProgress.start()
				this.timer = setInterval(() => NProgress.inc(), 400)
			}
			if(nextProps.step>=0) {
				if(this.timer) clearInterval(this.timer)
				NProgress.set(nextProps.step)
			}
		} else {
			if(this.timer) clearInterval(this.timer)
			NProgress.set(0.9)
			setTimeout(() => {if(!this.unmounted && !this.props.running) NProgress.done()}, 800)
		}
	}*/
	
	componentWillUnmount() {
		//console.log('unmount')
		this.unmounted = true
		if(this.timer) clearInterval(this.timer)
	}
	
	render() {
		return (
			<span/>
		)
	}
}

function mapStateToProps(state) {
	//console.log(state.page.loadingLocation)
	//console.log(state.admin.saving)
	return {
		running: state.page.loadingLocation || state.admin.saving,
		step: state.admin.saveStep
	}
}

export default connect(mapStateToProps)(NProgressBar);



// WEBPACK FOOTER //
// ./src/fm/lib/NProgressBar.js